import React from "react";
import { IInputNumberProps, EInputNumberWidths } from "./interface";
import { Row, InputNumber } from "antd";
import "./index.less";
import ZTypography from "../ZTypography";

const { ZText } = ZTypography;

const ZInputNumber: React.FC<IInputNumberProps> = ({
	addOnAfter = "",
	defaultString = "",
	width = EInputNumberWidths.sm,
	className = "",
	zref,
	...rest
}) => {
	return (
		<div className="z-input-number">
			{addOnAfter ? (
				<Row className={`w-full flex ${className}`}>
					<InputNumber
						type="number"
						className={`input-number ${
							width === "full"
								? `input-number-width-${width}-has-addon`
								: `input-number-width-${width}`
						} input-number-yes-addon rounded-none rounded-l-md`}
						ref={zref}
						{...rest}
					/>
					<div
						className={
							"add-on-after rounded-none rounded-r-md border-0 border-t border-r border-b flex items-center"
						}
					>
						<ZText level={0} className="px-1" colorVariant={7}>
							{addOnAfter}
						</ZText>
					</div>
				</Row>
			) : (
				<InputNumber
					type="number"
					className={`input-number input-number-width-${width} input-number-no-addon rounded-none rounded-l-md ${className}`}
					ref={zref}
					{...rest}
				/>
			)}
		</div>
	);
};

export { EInputNumberWidths as InputNumberWidths };

export default ZInputNumber;
